"use strict";
'kiwi public';

/** @module */

/**
 * Plays alert sounds
 */
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioManager = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var AudioManager = exports.AudioManager = /*#__PURE__*/function () {
  function AudioManager(audio) {
    (0, _classCallCheck2.default)(this, AudioManager);
    this.lastPlayed = 0;
    this.audio = audio;
  }

  /** Play the alert sound */
  return (0, _createClass2.default)(AudioManager, [{
    key: "play",
    value: function play() {
      // Only play the bleep once every 2 seconds
      if (!this.lastPlayed || Date.now() - this.lastPlayed > 2000) {
        this.audio.play();
        this.lastPlayed = Date.now();
      }
    }
  }, {
    key: "listen",
    value: function listen(state) {
      var _this = this;
      state.$on('audio.bleep', function () {
        _this.play();
      });
    }

    /** Watch the Kiwi state for any message highlights and play an alert */
  }, {
    key: "watchForMessages",
    value: function watchForMessages(state) {
      var _this2 = this;
      state.$on('message.new', function (event) {
        var message = event.message,
          buffer = event.buffer;
        if (buffer.setting('mute_sound')) {
          return;
        }
        var ignoreTypes = ['connection', 'traffic', 'mode', 'nick'];
        if (ignoreTypes.indexOf(message.type) > -1) {
          return;
        }
        if (message.ignore || buffer.isSpecial()) {
          return;
        }
        var shouldBleep = buffer.getNetwork().nick !== message.nick && (message.isHighlight && buffer.setting('alert_on') === 'highlight' || buffer.setting('alert_on') === 'message');
        var isActiveBuffer = state.getActiveBuffer() === buffer;
        var inFocus = isActiveBuffer && state.ui.app_has_focus;
        if (shouldBleep || buffer.isQuery() && !inFocus) {
          _this2.play();
        }
      });
    }
  }]);
}();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AudioManager"]
window._kiwi_exports.libs.AudioManager = exports.default ? exports.default : exports;
